import { wrapWithMaxWidth } from '../../../echarts/util/tooltip';

/*
function calculateTooltipProps(barsNum) {
  if (barsNum < 12) {
    return {
      cols: 1,
      width: 300,
    };
  }
  return {
    cols: 2,
    width: 600,
  };
} */

function reduceLabels(colsNumber = 1) {
  let accumulated = 1;
  return (reduced, next) => {
    if (accumulated < colsNumber) {
      accumulated += 1;
      return reduced.concat(' | ').concat(next);
    }
    accumulated = 1;
    return reduced.concat('<br/>').concat(next);
  };
}

export default function getTooltipFormatter(echartData) {
  return (bars) => {
    const firstBar = bars[0];
    const title = firstBar.axisValueLabel;

    const barsResults = bars
      .map((bar) => {
        const percent = bar.data.slice(1)[bar.componentIndex];
        return {
          barName: bar.seriesName,
          iconSpan: bar.marker,
          percent,
          empty: percent === null || percent === undefined,
        };
      })
      // .filter((params) => !params.empty)
      .map((params) => `${params.iconSpan} ${params.barName}: ${params.percent}%`)
      .reduce(reduceLabels(1));

    return wrapWithMaxWidth(`${title}<br/>${barsResults}`, 450);
  };
}
